<template lang="html">
  <div class="row">
    <div class="col-xl-6 offset-xl-3">
      <!-- <h5>{{graphTitle}}</h5> -->
      <div class="spacer"></div>
      <slot></slot>
    </div>

    <div class="col col-lg-5" v-if="false">
      <h5>{{ $t('graph.time_period_filter_label') }}</h5>
      <div class="spacer"></div>

      <!-- Sélection de la période de temps -->
      <div class="form-group">
        <label>{{ $t('graph.time_period') }} :</label>
        <b-form-select class="custom-select" required
          v-model="sPeriod"
          @change="$emit('filter-graph',{period:sPeriod, ibans:sIbans, contacts:sContacts, docTypes:sDocTypes})"
          :options="periodOptions">
        </b-form-select>
      </div>
      <div class="spacer"></div>

      <!-- Filtre par IBAN -->
      <!-- <b-form-group :label="$i18n.t('filter.fltr_iban')" v-if="!filterDocuments">
        <b-form-checkbox-group
          v-model="sIbans"
          :options="ibanOptions">
        </b-form-checkbox-group>
      </b-form-group>
      <div class="spacer"></div> -->

      <!-- Filtre par Contact -->
      <b-form-group :label="$i18n.t('filter.fltr_cntct')" v-if="!filterDocuments">
        <b-form-checkbox-group
          v-model="sContacts"
          :options="contactOptions">
        </b-form-checkbox-group>
      </b-form-group>

      <!-- Filtre par type de document -->
      <!-- <div class="row form-group ml-sm-0">
        {{ $i18n.t('filter.fltr_doc_type') }}
      </div>
      <div class="row form-group ml-sm-2">
        <b-form-checkbox v-for="docTypeOption in docTypeOptions" :key="docTypeOption.value"
          v-model="sDocTypes"
          :value="docTypeOption.value"
          class="col-sm-6">
          {{ docTypeOption.text }}
        </b-form-checkbox>
      </div> -->

      <div class="spacer"></div>

      <b-button @click="$emit('filter-graph',{period:sPeriod, ibans:sIbans, contacts:sContacts, docTypes:sDocTypes})" v-if="false">
        {{ $t('filter.appl_fltr') }}
      </b-button>
      <!-- <b-button @click="clearFilter()">{{ $t('filter.clr_fltr') }}</b-button> -->

      <div class="spacer"></div>

      <!-- <b-form-group :label="$i18n.t('filter.dsplyd_data')"
                    v-if="trueValueLabel && falseValueLabel">
        <b-form-radio-group
          v-model="showing"
          :options="showOptions"
          plain
          name="plain-inline"
        ></b-form-radio-group>
        <b-form-radio-group>
          <b-form-radio
          v-model="showing"
          v-for="option in showOptions"
          :value="option.value"
          :key="option.value"
        >{{option.text}}</b-form-radio>
      </b-form-radio-group>
    </b-form-group> -->

    </div>
  </div>
</template>

<script>
import { capitalizeFirstLetter } from '@/helpers/format.js'

export default {
  props: ['graphTitle', 'periodes', 'ibans', 'contacts', 'documentTypes', 'value', 'trueValueLabel', 'falseValueLabel'], // value for v-model
  data () {
    return {
      periodOptions: [],
      sPeriod: 'lastMonth',
      ibanOptions: [],
      sIbans: [],
      contactOptions: [],
      sContacts: [],
      docTypeOptions: [],
      sDocTypes: [],
      showOptions: [],
      filterDocuments: false
    }
  },
  created () {
    let fromValueToText = {
      'lastDay': this.$i18n.t('graph.day_label'),
      'lastWeek': this.$i18n.t('graph.week_label'),
      'lastMonth': this.$i18n.t('graph.month_label'),
      'lastYear': this.$i18n.t('graph.year_label')
    }
    this.periodOptions = this.periodes.map(entry => ({value: entry, text: capitalizeFirstLetter(fromValueToText[entry])}))
    this.ibanOptions = this.ibans.map(entry => ({value: entry.iban, text: entry.name}))
    this.contactOptions = this.contacts.map(entry => ({value: entry.id, text: entry.alias}))
    if (this.documentTypes) {
      this.docTypeOptions = this.documentTypes.map(entry => ({value: entry.id, text: entry.label}))
    }
    this.showOptions = [{text: this.trueValueLabel, value: true}, {text: this.falseValueLabel, value: false}]
    // this.filterDocuments = this.graphTitle === this.$t('graph.snt_and_rcvd_docs')
    this.filterDocuments = true
  },
  mounted () {
  },
  methods: {
    clearFilter () {
      this.sIbans = []
      this.sContacts = []
      this.sDocTypes = []
      this.$emit('clear-filter')
    },
    capitalize (word) {
      return capitalizeFirstLetter(word)
    }
  },
  computed: {
    // Pour le v-model
    showing: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="css" scoped>
.spacer {
  margin-top: 40px;
  margin-bottom: 40px;
}
*:focus{ outline: none; } /* Enlever le border noir horrible sous Chrome (default border color for focused form elements) */
</style>
